import { Component } from '@angular/core';
import {
  ProductReference,
  ProductReferenceService,
  Product,
} from '@spartacus/core';
import { CurrentProductService } from '@spartacus/storefront';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';

@Component({
    selector: 'app-uig-product-sets-tab',
    templateUrl: './uig-product-sets-tab.component.html',
    styleUrls: ['./uig-product-sets-tab.component.scss'],
    standalone: false
})
export class UigProductSetsTabComponent {
  constructor(
    private currentProductService: CurrentProductService,
    private productReferenceService: ProductReferenceService
  ) {}

  protected get productCode$(): Observable<string> {
    return this.currentProductService.getProduct().pipe(
      filter(Boolean),
      map((product: Product) => product.code),
      tap((_) => this.productReferenceService.cleanReferences())
    );
  }

  items$: Observable<Observable<Product>[]> = this.productCode$.pipe(
    tap((productCode) =>
      this.productReferenceService.loadProductReferences(productCode, 'SET')
    ),
    switchMap((productCode) =>
      this.getProductReferences(productCode, "SET")
    )
  );

  private getProductReferences(
    code: string,
    referenceType: string
  ): Observable<Observable<Product>[]> {
    return this.productReferenceService
      .getProductReferences(code, referenceType)
      .pipe(
        filter(Boolean),
        map((references: ProductReference[]) =>
          {
            return references.map((reference) => of(reference.target));
          }
        )
      );
  }
}
